import { Box, Chip, Typography } from '@mui/material';
import moment from 'moment';

const StatusCell = ({ row = {} }) => {
  const color = {
    PENDENTE: 'warning',
    CONCLUIDO: 'success',
    CANCELADO: 'error',
  };

  const label = row?.status === 'PENDENTE' ? row?.situacao : row?.status;

  return (
    <Box flex={1} display="flex">
      <Chip
        size="small"
        label={label}
        sx={{ flex: 1 }}
        color={color[row?.status]}
      />
    </Box>
  );
};

const DocumentoCell = ({ row = {} }) => {
  const lines = [
    {
      label: 'Data de Emissão',
      value:
        moment(row?.dtemissao).isValid() &&
        moment(row?.dtemissao).format('DD/MM/YYYY [às] HH:mm'),
    },
    {
      label: 'Emitido por',
      value: row?.user,
    },
    {
      label: 'Cliente',
      value: row?.cliente,
    },
    {
      label: 'Filial',
      value: row?.filial,
    },
    {
      label: 'Vendedor',
      value: row?.vendedor,
    },
    {
      label: 'Código do Fabricante',
      value: row?.fabricante,
    },
  ];

  const att =
    Boolean(row?.dtmodificacao) && moment(row?.dtmodificacao).isValid()
      ? moment(row?.dtmodificacao).format('DD/MM/YYYY [às] HH:mm')
      : null;

  const duration = moment
    .duration(moment().diff(moment(row?.dtmodificacao)))
    .asDays();
  const color = duration > 10 ? 'red' : duration >= 5 ? 'orange' : null;

  return (
    <Box flex={1}>
      <Typography fontWeight="bold" mb={1} variant="body1">
        {row?.documento}
      </Typography>
      {lines?.map(
        ({ label, value }, i) =>
          Boolean(value) && (
            <Box key={i?.toString()} display="flex">
              <Typography flex={1} variant="caption" fontWeight="bold">
                {label}:{' '}
              </Typography>
              <Typography flex={2} variant="caption">
                {value}
              </Typography>
            </Box>
          )
      )}
      {Boolean(att) && (
        <Box flex={1} textAlign="end">
          <Typography color={color} variant="caption">
            Última Modificação em {att}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

const ProdutoCell = ({ row = {} }) => {
  const lines = [
    {
      label: 'Marca',
      value: row?.marca,
    },
    {
      label: 'Quantidade',
      value: (row?.quantidade || 0) + ' ' + (row?.unidade_medida || ''),
    },
    {
      label: 'Preço Unitário',
      value: (row?.preco || 0)?.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
      }),
    },
    {
      label: 'Subtotal',
      value: ((row?.quantidade || 0) * (row?.preco || 0))?.toLocaleString(
        'pt-br',
        { style: 'currency', currency: 'BRL' }
      ),
    },
  ];
  return (
    <Box flex={1}>
      <Typography fontWeight="bold" mb={1} variant="body1">
        {row?.produto}
      </Typography>
      {lines?.map(
        ({ label, value }, i) =>
          Boolean(value) && (
            <Box key={i?.toString()} display="flex">
              <Typography flex={1} variant="caption" fontWeight="bold">
                {label}:{' '}
              </Typography>
              <Typography flex={2} variant="caption">
                {value}
              </Typography>
            </Box>
          )
      )}
    </Box>
  );
};

const VinculosCell = ({ row = {} }) => {
  const lines = [
    {
      label: 'Origem',
      value: row?.origem,
    },
    {
      label: 'Devolução',
      value: row?.devolucao,
    },
    {
      label: 'Remessa',
      value: row?.remessa,
    },
    {
      label: 'Retorno',
      value: row?.retorno,
    },
    {
      label: 'Retorno da Garantia',
      value: row?.retorno_garantia,
    },
  ];
  return (
    <Box flex={1}>
      {lines?.map(
        ({ label, value }, i) =>
          Boolean(value) && (
            <Box key={i?.toString()} display="flex">
              <Typography flex={1} variant="caption" fontWeight="bold">
                {label}:{' '}
              </Typography>
              <Typography flex={2} variant="caption">
                {value}
              </Typography>
            </Box>
          )
      )}
    </Box>
  );
};

const columnOverrides = [
  {
    field: 'status',
    renderCell: (props) => <StatusCell {...props} />,
  },
  {
    field: 'documento',
    renderCell: (props) => <DocumentoCell {...props} />,
  },
  {
    field: 'produto',
    renderCell: (props) => <ProdutoCell {...props} />,
  },
  {
    field: 'vinculos',
    renderCell: (props) => <VinculosCell {...props} />,
  },
];

export default columnOverrides;
